import { render, staticRenderFns } from "./DataSource.vue?vue&type=template&id=d935cd84&scoped=true&"
import script from "./DataSource.vue?vue&type=script&lang=ts&"
export * from "./DataSource.vue?vue&type=script&lang=ts&"
import style0 from "./DataSource.vue?vue&type=style&index=0&id=d935cd84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d935cd84",
  null
  
)

export default component.exports